export default __webpack_public_path__ + "static/blob6-2f9506735ae9116fe1fc5ae0b0cd1b9e.svg";